module.exports = __webpack_public_path__ + "img/leticiabolzani.e323d3a4.jpg";